import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, type AppNotification } from '../api';

/** Sino de notificações in-app: faz polling, mostra não-lidas e navega ao clicar. */
export function NotificationBell() {
  const nav = useNavigate();
  const [items, setItems] = useState<AppNotification[]>([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  function reload() {
    api.listNotifications().then(({ notifications, unread }) => {
      setItems(notifications);
      setUnread(unread);
    }).catch(() => undefined);
  }

  useEffect(() => {
    reload();
    const t = setInterval(reload, 20000);
    return () => clearInterval(t);
  }, []);

  // Fecha ao clicar fora.
  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  async function openItem(n: AppNotification) {
    if (!n.readAt) {
      await api.markNotificationRead(n.id).catch(() => undefined);
      setItems((prev) => prev.map((x) => (x.id === n.id ? { ...x, readAt: new Date().toISOString() } : x)));
      setUnread((u) => Math.max(0, u - 1));
    }
    if (n.link) {
      if (/^https?:\/\//.test(n.link)) window.open(n.link, '_blank', 'noreferrer');
      else {
        setOpen(false);
        nav(n.link);
      }
    }
  }

  async function markAll() {
    await api.markAllNotificationsRead().catch(() => undefined);
    setItems((prev) => prev.map((x) => ({ ...x, readAt: x.readAt ?? new Date().toISOString() })));
    setUnread(0);
  }

  return (
    <div className="notif" ref={ref}>
      <button type="button" className="notif-btn" onClick={() => setOpen((o) => !o)} title="Notificações" aria-label="Notificações">
        🔔
        {unread > 0 && <span className="notif-badge">{unread > 9 ? '9+' : unread}</span>}
      </button>
      {open && (
        <div className="notif-panel">
          <div className="notif-head">
            <strong>Notificações</strong>
            {unread > 0 && <button type="button" className="notif-markall" onClick={markAll}>marcar todas</button>}
          </div>
          {items.length === 0 ? (
            <div className="notif-empty">Sem notificações.</div>
          ) : (
            <ul className="notif-list">
              {items.map((n) => (
                <li key={n.id} className={`notif-item ${n.readAt ? '' : 'is-unread'} ${n.link ? 'is-link' : ''}`} onClick={() => openItem(n)}>
                  <div className="notif-item-title">{n.title}</div>
                  {n.body && <div className="notif-item-body">{n.body}</div>}
                  <div className="notif-item-time">{new Date(n.createdAt).toLocaleString()}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
